import script from "./BrushMapPage.vue?vue&type=script&lang=ts&setup=true"
export * from "./BrushMapPage.vue?vue&type=script&lang=ts&setup=true"

import "./BrushMapPage.vue?vue&type=style&index=0&id=d4934fe8&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d4934fe8"]])

export default __exports__